import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import NetworksListTab from './NetworksListTab';
import OffersListTab from '../offers/OffersListTab';

const SHARED_PARAMS = ['q', 'tags', 'page', 'status', 'network'];

export default function NetworksPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'networks';

  const onTabChange = (_: React.SyntheticEvent, v: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      SHARED_PARAMS.forEach((k) => next.delete(k));
      next.set('tab', v);
      return next;
    }, { replace: true });
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={600} sx={{ mb: 2 }}>Networks</Typography>
      <Tabs value={tab} onChange={onTabChange} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Networks" value="networks" />
        <Tab label="Offers" value="offers" />
      </Tabs>
      {tab === 'offers' ? <OffersListTab /> : <NetworksListTab />}
    </Box>
  );
}
